import { render, staticRenderFns } from "./RacerRanking.vue?vue&type=template&id=008490f2&scoped=true"
import script from "./RacerRanking.vue?vue&type=script&lang=js"
export * from "./RacerRanking.vue?vue&type=script&lang=js"
import style0 from "./RacerRanking.vue?vue&type=style&index=0&id=008490f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008490f2",
  null
  
)

export default component.exports